// extracted by mini-css-extract-plugin
export default {"container":"Words_container__hAGEe","title":"Words_title__0OCNL","subtitle":"Words_subtitle__vrmGz"};